import {nullOrUndefinedCheck} from '@/core/services/funcs';

// 랙
class Rack {
  constructor(farmRackNo = 0, batchCode = null, connectNm = null, fno = 0, growType = null, mno = 0, potCount = 0, rackColumn = 0, rackLocation = null, rackRow = 0, systemId = 0) {
    this.farmRackNo = farmRackNo;
    this.batchCode = batchCode;
    this.connectNm = connectNm;
    this.fno = fno;
    this.growType = growType;
    this.mno = mno;
    this.potCount = potCount;
    this.rackColumn = rackColumn;
    this.rackLocation = rackLocation;
    this.rackRow = rackRow;
    this.systemId = systemId;
  }
   static objectRack(objectRack) {
    return new Rack(
      objectRack.farmRackNo,
      objectRack.batchCode, 
      objectRack.connectNm, 
      objectRack.fno, 
      objectRack.growType, 
      objectRack.mno, 
      objectRack.potCount, 
      objectRack.rackColumn, 
      objectRack.rackLocation, 
      objectRack.rackRow, 
      objectRack.systemId
    )
   }

   init(){
    this.farmRackNo = 0;
    this.batchCode = null;
    this.connectNm = null;
    this.fno = 0;
    this.growType = null;
    this.mno = 0;
    this.potCount = 0;
    this.rackColumn = 0;
    this.rackLocation = null;
    this.rackRow = 0;
    this.systemId = 0;
   }

   updateRackValue(value) {
      this.farmRackNo = value.farmRackNo
      this.systemId = value.systemId
      this.rackLocation = value.rackLocation
      this.rackRow = value.rackRow
      this.rackColumn = value.rackColumn
      this.potCount = value.potCount
   }

   // 등록 유효성 검증
   insertValidation(){

    if(this.rackLocation === null || this.rackLocation === undefined || this.rackLocation === '' || 
      this.systemId === null || this.systemId === undefined || this.systemId === 0 ||
      this.rackRow === null || this.rackRow === undefined || this.rackRow < 0 ||
      this.rackColumn === null || this.rackColumn === undefined || this.rackColumn < 0 ||
      this.potCount === null || this.potCount === undefined || this.potCount < 0 ||
      this.fno === null || this.fno === undefined || this.fno === 0
    ) {
      // 오류
      return 1
    }
    return 0
   }

   // 수정 유효성 검증
   updateValidation(){
    if(this.rackLocation === null || this.rackLocation === undefined || this.rackLocation === '' || 
      this.systemId === null || this.systemId === undefined || this.systemId === 0 ||
      this.rackRow === null || this.rackRow === undefined || this.rackRow < 0 ||
      this.rackColumn === null || this.rackColumn === undefined || this.rackColumn < 0 ||
      this.potCount === null || this.potCount === undefined || this.potCount < 0 ||
      this.farmRackNo === null || this.farmRackNo === undefined || this.farmRackNo === 0
    ) {
      // 오류
      return 1
    }
    return 0
   }
}

// 랙 리스트
class RackList {
  constructor(allRacks = []) {
    this.allRacks = allRacks;
  }

  // 전체 Rack 객체 추가
  addRack(rack) {
    if (rack instanceof Rack) {
      this.allRacks.push(rack);
    } else {
      throw new Error("Only Rack instances can be added.");
    }
  }

}

// 랙 연결 제어기
class RackConnect {
  constructor(connectNmList = [], rackConnect = 0){
    this.connectNmList = connectNmList
    this.rackConnect = rackConnect
  }
}

// 랙 그룹
class RackGroup {
  constructor(rackGroupNo = 0, rackGroupName = null, farmRackNo = 0, rackLocation = null, plantingTotalCapa = 0){
    this.rackGroupNo = rackGroupNo
    this.rackGroupName = rackGroupName
    this.farmRackNo = farmRackNo
    this.rackLocation = rackLocation
    this.plantingTotalCapa = plantingTotalCapa
  }

  static objectRackGroup(objectRackGroup) {
    return new RackGroup(
      objectRackGroup.rackGroupNo,
      objectRackGroup.rackGroupName, 
      objectRackGroup.farmRackNo, 
      objectRackGroup.rackLocation, 
      objectRackGroup.plantingTotalCapa
    )
   }
}

// 랙 구역 리스트
class RackGroupList {
  constructor(){
    this.rackGroupList = []
  }

  addRackGroup(rackGroup){
    
    if (rackGroup instanceof RackGroup) {
      this.rackGroupList.push(rackGroup);
    } else {
      throw new Error("Only RackGroup instances can be added.");
    }
  }
}

// 랙 등록
class SectionRack {
  constructor(rackGroupNo = 0, rackGroupName = null, plantingTotalCapa = 0, farmRackList = []) {
    this.rackGroupNo = rackGroupNo
    this.rackGroupName = rackGroupName
    this.plantingTotalCapa = plantingTotalCapa
    this.farmRackList = farmRackList
  }

  init(){
    this.rackGroupNo = 0
    this.rackGroupName = null
    this.plantingTotalCapa = 0
    this.farmRackList = []
  }

  // 등록 유효성 검증
  insertValidate() {
    if(nullOrUndefinedCheck(this.rackGroupName) === null || this.rackGroupName.trim().length === 0 ||
      nullOrUndefinedCheck(this.plantingTotalCapa) === null || Number(this.plantingTotalCapa) < 0 || 
      nullOrUndefinedCheck(this.farmRackList) === null || this.farmRackList.length ===0 
    ) {
      
      return true
    }
  }

  request(){
    const request = {
      rackGroupName : this.rackGroupName,
      plantingTotalCapa : this.plantingTotalCapa,
      farmRackNoList : this.farmRackList.map(item => item.farmRackNo)
    }
    return request
  }
}



export {Rack, RackList, RackConnect, RackGroup, RackGroupList, SectionRack};